/*
 * 軽量スライダー (vanilla JS)
 *
 * - data-slider              : スライダーのルート要素
 * - data-slider-list         : スライドコンテナ (overflow-x: auto + scroll-snap)
 * - data-slider-item         : 各スライド要素
 * - data-slider-prev / -next : 戻る/進むボタン
 * - data-slider-dots         : ページネーションドットを差し込むコンテナ
 * - data-autoplay            : ミリ秒指定で自動再生 (0 または未指定で無効)
 * - data-slider-loop         : false 指定で無限ループ用クローンを無効化
 *
 * 仕様:
 * - 2 アイテム以上ある場合は無限ループ（先頭に最終要素のクローン、末尾に先頭要素のクローンを挿入）
 * - 中央寄せ (Slick の centerMode 相当): scroll-snap-align: center + 親要素の左右パディング
 * - 各サイドからのチラ見せ: クローン挿入で前後の隣接スライドが視覚的に常に存在する
 *
 * セキュリティレビュー方針:
 * - innerHTML / outerHTML / document.write / insertAdjacentHTML は使わない
 * - DOM 操作は textContent / setAttribute / createElement / cloneNode のみ
 * - cloneNode の対象はサーバ Liquid で escape 済みの DOM のため XSS 経路なし
 * - eval / Function() / 文字列 setTimeout は使わない
 * - 外部入力 (URL / cart attributes / postMessage 等) は扱わない
 * - data-autoplay は parseInt + NaN/負数チェックで数値以外を除外
 */
(function () {
  'use strict';

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function disableInteractiveDescendants(node) {
    var focusables = node.querySelectorAll('a, button, [tabindex]');
    for (var i = 0; i < focusables.length; i++) {
      focusables[i].setAttribute('tabindex', '-1');
    }
  }

  function initSlider(root) {
    if (root.dataset.sliderInitialized === 'true') return;

    var list = root.querySelector('[data-slider-list]');
    if (!list) return;

    var originals = Array.prototype.slice.call(list.querySelectorAll('[data-slider-item]'));
    if (originals.length === 0) return;

    var dotsContainer = root.querySelector('[data-slider-dots]');
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');

    var autoplayMs = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    if (isNaN(autoplayMs) || autoplayMs < 0) autoplayMs = 0;

    var realCount = originals.length;
    var loop = realCount > 1 && root.getAttribute('data-slider-loop') !== 'false';

    // クローンを挿入して無限ループを再現
    if (loop) {
      var lastClone = originals[realCount - 1].cloneNode(true);
      lastClone.setAttribute('data-slider-clone', '');
      lastClone.setAttribute('aria-hidden', 'true');
      disableInteractiveDescendants(lastClone);
      list.insertBefore(lastClone, list.firstChild);

      var firstClone = originals[0].cloneNode(true);
      firstClone.setAttribute('data-slider-clone', '');
      firstClone.setAttribute('aria-hidden', 'true');
      disableInteractiveDescendants(firstClone);
      list.appendChild(firstClone);
    }

    // 全アイテム (クローン含む) のリスト
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-slider-item]'));
    // 実アイテムは raw index realStart..realEnd
    var realStart = loop ? 1 : 0;
    var realEnd = loop ? realCount : realCount - 1;

    root.dataset.sliderInitialized = 'true';

    var rawIndex = realStart;
    var autoplayTimer = null;
    var scrollDebounce = null;
    var jumping = false;

    function getRealIndex() {
      if (!loop) return rawIndex;
      if (rawIndex === 0) return realCount - 1; // clone-last
      if (rawIndex === items.length - 1) return 0; // clone-first
      return rawIndex - 1;
    }

    function buildDots() {
      if (!dotsContainer) return;
      while (dotsContainer.firstChild) dotsContainer.removeChild(dotsContainer.firstChild);
      var initialRealIdx = getRealIndex();
      for (var i = 0; i < realCount; i++) {
        (function (realIdx) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'slider-dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', realIdx === initialRealIdx ? 'true' : 'false');
          dot.setAttribute('aria-label', (realIdx + 1) + ' 番目のスライドへ');
          dot.addEventListener('click', function () {
            goToRaw(realStart + realIdx);
            restartAutoplay();
          });
          dotsContainer.appendChild(dot);
        })(i);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.slider-dot');
      var realIdx = getRealIndex();
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-selected', i === realIdx ? 'true' : 'false');
      }
    }

    function scrollToItem(rawIdx, smooth) {
      if (rawIdx < 0 || rawIdx >= items.length) return;
      var target = items[rawIdx];
      if (!target) return;
      var targetCenter = target.offsetLeft + target.offsetWidth / 2;
      var listCenter = list.clientWidth / 2;
      var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      var scrollTo = clamp(targetCenter - listCenter, 0, maxScroll);
      if ('scrollTo' in list) {
        list.scrollTo({ left: scrollTo, behavior: smooth === false ? 'auto' : 'smooth' });
      } else {
        list.scrollLeft = scrollTo;
      }
    }

    function goToRaw(targetRaw) {
      // クローン含む items 範囲外にならないようにクランプ
      // (端を超えた場合は checkLoopJump が後でサイレントに実 item 位置へ巻き戻す)
      if (targetRaw < 0) targetRaw = 0;
      if (targetRaw >= items.length) targetRaw = items.length - 1;
      rawIndex = targetRaw;
      scrollToItem(rawIndex, true);
      updateDots();
    }

    function findClosestRawIndex() {
      var listScrollCenter = list.scrollLeft + list.clientWidth / 2;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var c = items[i].offsetLeft + items[i].offsetWidth / 2;
        var d = Math.abs(c - listScrollCenter);
        if (d < minDist) {
          minDist = d;
          closest = i;
        }
      }
      return closest;
    }

    function checkLoopJump() {
      if (!loop || jumping) return;
      if (rawIndex === 0) {
        // clone-last 上にいる → 実アイテムの最終位置へサイレントジャンプ
        jumping = true;
        rawIndex = realEnd;
        scrollToItem(rawIndex, false);
        setTimeout(function () { jumping = false; }, 60);
      } else if (rawIndex === items.length - 1) {
        // clone-first 上にいる → 実アイテムの先頭位置へサイレントジャンプ
        jumping = true;
        rawIndex = realStart;
        scrollToItem(rawIndex, false);
        setTimeout(function () { jumping = false; }, 60);
      }
    }

    function onScroll() {
      if (jumping) return;
      if (scrollDebounce) clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        var newRaw = findClosestRawIndex();
        if (newRaw !== rawIndex) {
          rawIndex = newRaw;
          updateDots();
        }
        // rawIndex 変化の有無に関わらずクローン位置のチェックは毎回行う
        // (autoplay や goToRaw 経由でクローン位置に到達した場合、newRaw === rawIndex で
        //  この外に出さないと巻き戻し処理が走らず、次の goToRaw(rawIndex+1) で範囲外になる)
        checkLoopJump();
      }, 120);
    }

    list.addEventListener('scroll', onScroll, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToRaw(rawIndex - 1);
        restartAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToRaw(rawIndex + 1);
        restartAutoplay();
      });
    }

    function startAutoplay() {
      if (autoplayMs <= 0 || !loop) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        goToRaw(rawIndex + 1);
      }, autoplayMs);
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    // hover / focus / touch では autoplay を停止しない（連続再生）
    // タブ非表示時のみ停止して再開時に再生する（リソース節約）
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    buildDots();
    updateDots();

    function positionInitial() {
      scrollToItem(rawIndex, false);
    }

    // 初期位置: rAF で次フレームで配置 + window.load で最終確定
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(positionInitial);
    } else {
      positionInitial();
    }
    window.addEventListener('load', function () {
      positionInitial();
      startAutoplay();
    });

    // ResizeObserver でレイアウト変動 (ウィンドウリサイズ、CSS 遅延適用、フォント読み込み等) に追従
    if (typeof ResizeObserver === 'function') {
      var resizeDebounce = null;
      var ro = new ResizeObserver(function () {
        if (jumping) return;
        if (resizeDebounce) clearTimeout(resizeDebounce);
        resizeDebounce = setTimeout(positionInitial, 80);
      });
      ro.observe(list);
      if (items[rawIndex]) ro.observe(items[rawIndex]);
    }

    if (document.readyState === 'complete') {
      startAutoplay();
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-slider]');
    for (var i = 0; i < roots.length; i++) {
      initSlider(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
